import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin`;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach token from localStorage as fallback (in case cookies are blocked)
client.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-logout on 401 (expired / invalid token, e.g. after backend redeploy)
// Only redirects when the user is actively on an admin page — never affects public routes.
client.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 401 && !url.includes("/login")) {
      localStorage.removeItem("admin_token");
      if (
        typeof window !== "undefined" &&
        window.location.pathname.startsWith("/admin") &&
        !window.location.pathname.endsWith("/admin/login")
      ) {
        window.location.replace("/admin/login");
      }
    }
    return Promise.reject(error);
  }
);

export const adminApi = {
  login: (email, password) =>
    client.post("/login", { email, password }).then((r) => r.data),
  logout: () => client.post("/logout").then((r) => r.data),
  me: () => client.get("/me").then((r) => r.data),
  listLeads: (params = {}) =>
    client.get("/leads", { params }).then((r) => r.data),
  getLead: (id) => client.get(`/leads/${id}`).then((r) => r.data),
  updateLead: (id, data) =>
    client.patch(`/leads/${id}`, data).then((r) => r.data),
  stats: () => client.get("/stats").then((r) => r.data),
  generateSocialPost: (id) =>
    client.post(`/leads/${id}/social-post`, null, { timeout: 90000 }).then((r) => r.data),
  exportCsvUrl: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return `${API}/leads.csv${qs ? "?" + qs : ""}`;
  },
};

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Error inesperado";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}
